export const handleKeyDown = (event) => {
  const disabledBtn = event.target.classList.contains('disabled');
  if(!disabledBtn && (event.key === ' ' || event.key === 'Enter')) event.target.click();
}

export const actsAsFocusableProps = (props = {}) => {
  return {
    tabIndex: 0,
    ...props
  }
}
export const actsAsButtonProps = (props = {}) => {
  return {
    ...actsAsFocusableProps(),
    role: 'button',
    onKeyDown: handleKeyDown,
    ...props
  };
};